import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { API_KEY, API_ENDPOINTS, LANGUAGE, IMAGE_BASE_URL } from '../../config/api';
import './Genres.css';

const Genres = () => {
    const [genres, setGenres] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState(null);
    const [movies, setMovies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [moviesLoading, setMoviesLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const fetchGenres = async () => {
            try {
                const response = await axios.get(
                    `${API_ENDPOINTS.GENRES}?api_key=${API_KEY}&language=${LANGUAGE}`
                );
                setGenres(response.data.genres);
            } catch (error) {
                console.error('Error fetching genres:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchGenres();
    }, []);

    useEffect(() => {
        if (selectedGenre) {
            fetchMoviesByGenre(selectedGenre.id, 1);
        }
    }, [selectedGenre]);

    const fetchMoviesByGenre = async (genreId, pageNum = 1) => {
        try {
            setMoviesLoading(true);
            const response = await axios.get(
                `${API_ENDPOINTS.MOVIES_BY_GENRE(genreId)}&api_key=${API_KEY}&language=${LANGUAGE}&page=${pageNum}&sort_by=popularity.desc`
            );
            
            if (pageNum === 1) {
                setMovies(response.data.results);
            } else {
                setMovies(prev => [...prev, ...response.data.results]);
            }
            
            setTotalPages(response.data.total_pages);
            setPage(pageNum);
        } catch (error) {
            console.error('Error fetching movies by genre:', error);
        } finally {
            setMoviesLoading(false);
        }
    };

    const handleGenreClick = (genre) => {
        setSelectedGenre(genre);
        setPage(1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const loadMore = () => {
        if (selectedGenre && page < totalPages && !moviesLoading) {
            fetchMoviesByGenre(selectedGenre.id, page + 1);
        }
    };

    if (loading) {
        return (
            <div className="genres-page">
                <Header />
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Загрузка жанров...</p>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="genres-page">
            <Header />
            <div className="container-xl mt-4">
                <h1 className="page-title">
                    <span className="title-icon">🎭</span>
                    Жанры фильмов
                </h1>

                <div className="genres-container">
                    <div className="genres-sidebar">
                        <h2 className="sidebar-title">Выберите жанр</h2>
                        <div className="genres-list">
                            {genres.map(genre => (
                                <button
                                    key={genre.id}
                                    className={`genre-button ${selectedGenre?.id === genre.id ? 'active' : ''}`}
                                    onClick={() => handleGenreClick(genre)}
                                >
                                    {genre.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="movies-content">
                        {selectedGenre ? (
                            <>
                                <h2 className="selected-genre-title">
                                    {selectedGenre.name} ({movies.length} {movies.length === 1 ? 'фильм' : movies.length < 5 ? 'фильма' : 'фильмов'})
                                </h2>
                                
                                {moviesLoading && movies.length === 0 ? (
                                    <div className="loading-container">
                                        <div className="spinner"></div>
                                        <p>Загрузка фильмов...</p>
                                    </div>
                                ) : movies.length === 0 ? (
                                    <div className="no-results">
                                        Фильмы не найдены
                                    </div>
                                ) : (
                                    <>
                                        <div className="movies-grid">
                                            {movies.map(movie => (
                                                <Link
                                                    key={movie.id}
                                                    to={`/film/id/${movie.id}`}
                                                    className="movie-card"
                                                >
                                                    <div className="movie-card-poster">
                                                        <img
                                                            src={movie.poster_path ? `${IMAGE_BASE_URL}/w342${movie.poster_path}` : '/images/placeholder.jpg'}
                                                            alt={movie.title}
                                                        />
                                                        <div className="movie-card-overlay">
                                                            <div className="movie-card-rating">
                                                                ⭐ {movie.vote_average?.toFixed(1)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="movie-card-info">
                                                        <h3 className="movie-card-title">{movie.title}</h3>
                                                        <p className="movie-card-date">
                                                            {movie.release_date ? new Date(movie.release_date).getFullYear() : 'Дата неизвестна'}
                                                        </p>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>

                                        {page < totalPages && (
                                            <div className="load-more-container">
                                                <button
                                                    className="load-more-button"
                                                    onClick={loadMore}
                                                    disabled={moviesLoading}
                                                >
                                                    {moviesLoading ? 'Загрузка...' : 'Загрузить еще'}
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <div className="select-genre-prompt">
                                <p>👈 Выберите жанр слева, чтобы увидеть фильмы</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Genres;
